import userAPI from './userAPI'
import contentAPI from './contentAPI';
import jobAPI from './jobAPI';
import fileAPI from './fileAPI';
import assetAPI from './assetAPI';
import submissionAPI from './submissionAPI';
import audioAPI from './audioAPI';
import fontAPI from './fontAPI';

export default {
    ...userAPI,
    ...contentAPI,
    ...jobAPI,
    ...fileAPI,
    ...assetAPI,
    ...submissionAPI,
    ...audioAPI,
    ...fontAPI
}



// WEBPACK FOOTER //
// ./src/service/index.js